/**
 * Judgment Selling stack — barrel.
 * Prefer these modules over patching the legacy 5-axis soup.
 *
 * REJECTED (main WT evidence): healOwner persist + OOR formation-break chase
 * → wave deathsMean 0.55. Do not rewire Claim B.
 */
export * from "./traits";
export * from "./legacy-map";
export * from "./features";
export * from "./cover-subject";
export * from "./knobs";
export * from "./rescue";
export * from "./joint-seat";
export * from "./polar";
export * from "./matrix-policies";
export * from "./hero-architecture";
export * from "./hero-registry";
export * from "./hero-kit-stubs";
export * from "./soft-aa-isolate";
export * from "./survival-seek";
export * from "./role-policy-wire";
export * from "./encounter-break";
export * from "./encounter-pack-charge";
export * from "./kit-policy-apply";


import { dispositionOf, instinctOf } from "../raid-disposition";
import type { RaidUnit } from "../raid-types";
import { legacyToJudgment } from "./legacy-map";
import type { JudgmentTraits } from "./traits";

/** Resolve sell/judgment traits for a living unit (legacy adapter). */
export function judgmentOf(u: RaidUnit): JudgmentTraits {
  const d = dispositionOf(u);
  return legacyToJudgment({ ...d, instinct: instinctOf(u) });
}
